import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { TicketFormData } from '../../types';

interface TicketDueDateFieldProps {
  control: Control<TicketFormData>;
  errors: FieldErrors<TicketFormData>;
}

export const TicketDueDateField: React.FC<TicketDueDateFieldProps> = ({ 
  control, 
  errors 
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 500, color: '#34495e' }}>
        Due Date
      </Typography>
      <Controller
        name="dueDate"
        control={control}
        defaultValue=""
        rules={{ required: 'Due Date is required' }}
        render={({ field }) => (
          <TextField
            {...field}
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            error={!!errors.dueDate}
            helperText={errors.dueDate ? errors.dueDate.message : ''}
            sx={{ 
              width: '100%',
              '& .MuiOutlinedInput-root': {
                borderRadius: 1
              } 
            }}
          />
        )}
      />
    </Box>
  );
};